/*
 * ParfumLab yeni tasarım: koleksiyon filtreleri, mağazada dene paneli,
 * örnek yorum formu, kod kopyalama, sepette indirim kodu ve sözleşme onayı, yapışkan sepete ekle ve çıkış penceresi.
 */
(() => {
  const ready = (fn) => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn());

  /* İndirim kodu kopyalama: buton genişliği değişmez, simge onaya döner */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pl-copy]');
    if (!button) return;
    event.preventDefault();
    const done = () => {
      button.classList.add('is-copied');
      const toast = button.querySelector('.plr-offer__toast');
      if (toast) toast.textContent = 'Kopyalandı';
      clearTimeout(button._plrTimer);
      button._plrTimer = setTimeout(() => {
        button.classList.remove('is-copied');
        if (toast) toast.textContent = '';
      }, 1800);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(button.dataset.plCopy).then(done, done);
    else done();
  });

  /* ---------- İndirim kodu (sepet çekmecesi ve sepet sayfası; snippets/pl-cart-coupon) ----------
     Kodlar Shopify sepetine /cart/update.js ile yazılır (discount: virgülle ayrılmış kod listesi).
     Sepete uygulanamayan kod hemen geri alınır ve uyarı gösterilir. Sepet sayfası yenilenir, çekmecede
     mini-cart bölümü yeniden çizilir. Alan bir form içinde değil; Enter burada yakalanır. */
  const couponRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const couponMsgKey = 'plrCouponMsg';
  const couponMsg = (box, text, isError) => {
    const msg = box && box.querySelector('[data-plr-coupon-msg]');
    if (!msg) return;
    msg.textContent = text;
    msg.hidden = !text;
    msg.classList.toggle('is-error', Boolean(isError));
  };
  const couponBusy = (box, busy) => {
    box.classList.toggle('is-busy', busy);
    box.querySelectorAll('input, button').forEach((el) => (el.disabled = busy));
  };
  const couponCurrent = () => fetch(couponRoot + 'cart.js', { headers: { Accept: 'application/json' } })
    .then((r) => r.json())
    .then((cart) => (cart.discount_codes || []).map((d) => d.code));
  const couponUpdate = (codes, sections) => fetch(couponRoot + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(Object.assign({ discount: codes.join(',') }, sections ? { sections } : {})),
  }).then((r) => {
    if (!r.ok) throw new Error(String(r.status));
    return r.json();
  });
  const couponSame = (a, b) => a.trim().toUpperCase() === b.trim().toUpperCase();
  const couponDone = (box, state, text) => {
    const html = state && state.sections && state.sections['mini-cart'];
    const drawer = document.getElementById('mini-cart');
    if ((box.dataset.place || '').indexOf('drawer') === 0 && html && drawer && !document.body.classList.contains('template-cart')) {
      drawer.innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section').innerHTML;
      couponMsg([...drawer.querySelectorAll('[data-plr-coupon]')].find((el) => el.offsetParent && el.querySelector('[data-plr-coupon-msg]')) || drawer.querySelector('[data-plr-coupon]'), text, false);
      return;
    }
    try { sessionStorage.setItem(couponMsgKey, text); } catch (e) { /* yoksay */ }
    window.location.reload();
  };
  const couponApply = async (box) => {
    const input = box.querySelector('[data-plr-coupon-input]');
    const code = (input.value || '').trim();
    if (!code) {
      couponMsg(box, 'Lütfen bir indirim kodu girin.', true);
      input.focus();
      return;
    }
    couponMsg(box, '', false);
    couponBusy(box, true);
    try {
      const current = await couponCurrent();
      if (current.some((c) => couponSame(c, code))) {
        couponBusy(box, false);
        couponMsg(box, 'Bu kod zaten ekli.', true);
        return;
      }
      const sections = (box.dataset.place || '').indexOf('drawer') === 0 ? ['mini-cart'] : null;
      const state = await couponUpdate(current.concat(code), sections);
      const added = (state.discount_codes || []).find((d) => couponSame(d.code, code));
      if (!added || !added.applicable) {
        await couponUpdate(current, null);
        couponBusy(box, false);
        couponMsg(box, 'Bu kod geçerli değil ya da bu sepete uygulanamıyor.', true);
        return;
      }
      couponDone(box, state, ''); /* onay, uygulanan kod kutusunda (İndirim uygulandı) görünür */
    } catch (e) {
      couponBusy(box, false);
      couponMsg(box, 'Şu anda kod eklenemedi. Lütfen tekrar deneyin.', true);
    }
  };
  const couponRemove = async (box, code) => {
    couponBusy(box, true);
    try {
      const current = await couponCurrent();
      const sections = (box.dataset.place || '').indexOf('drawer') === 0 ? ['mini-cart'] : null;
      const state = await couponUpdate(current.filter((c) => !couponSame(c, code)), sections);
      couponDone(box, state, ''); /* tasarım: kod kaldırılınca alan ilk hâline döner, ayrıca mesaj yok */
    } catch (e) {
      couponBusy(box, false);
      couponMsg(box, 'Şu anda kod kaldırılamadı. Lütfen tekrar deneyin.', true);
    }
  };
  document.addEventListener('click', (event) => {
    const box = event.target.closest('[data-plr-coupon]');
    if (!box) return;
    /* Mobil sepet: teklif kutusundaki "İndirimi uygula" kodu tek dokunuşla ekler */
    const quick = event.target.closest('[data-plr-coupon-quick]');
    if (quick) {
      event.preventDefault();
      const input = box.querySelector('[data-plr-coupon-input]');
      if (input) input.value = quick.dataset.plrCouponQuick;
      couponApply(box);
      return;
    }
    if (event.target.closest('[data-plr-coupon-apply]')) {
      event.preventDefault();
      couponApply(box);
      return;
    }
    const remove = event.target.closest('[data-plr-coupon-remove]');
    if (remove) {
      event.preventDefault();
      couponRemove(box, remove.dataset.plrCouponRemove);
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || !event.target.matches('[data-plr-coupon-input]')) return;
    event.preventDefault();
    couponApply(event.target.closest('[data-plr-coupon]'));
  });
  ready(() => {
    let text = null;
    try {
      text = sessionStorage.getItem(couponMsgKey);
      if (text) sessionStorage.removeItem(couponMsgKey);
    } catch (e) { /* yoksay */ }
    if (text) couponMsg([...document.querySelectorAll('[data-plr-coupon]')].find((el) => el.offsetParent && el.querySelector('[data-plr-coupon-msg]')) || document.querySelector('[data-plr-coupon]'), text, false);
  });

  /* ---------- Sepet çekmecesi: sözleşme onayı (snippets/pl-cart-agree) ----------
     Kutu işaretli değilken "Ödeme" basılırsa tarayıcının balonu yerine kutunun altında uyarı çıkar;
     form zaten gönderilmez (required). İşaretlenince uyarı kalkar. */
  document.addEventListener('invalid', (event) => {
    const box = event.target;
    if (!box.matches || !box.matches('[data-plr-agree]')) return;
    event.preventDefault();
    const wrap = box.closest('[data-plr-agree-box]');
    wrap.classList.add('is-error');
    wrap.querySelector('[data-plr-agree-error]').hidden = false;
    box.focus({ preventScroll: false });
  }, true);
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-plr-agree]')) return;
    const wrap = event.target.closest('[data-plr-agree-box]');
    if (event.target.checked) {
      wrap.classList.remove('is-error');
      wrap.querySelector('[data-plr-agree-error]').hidden = true;
    }
  });

  /* ---------- Sepet sayfası, mobil: gerçek "Ödemeye geç" ekran dışındayken altta sabit çubuk ----------
     Çubuktaki düğme sepet formunu (#cart) aynı şekilde ödemeye gönderir (form="cart", name="checkout"). */
  ready(() => {
    if (!document.body.classList.contains('template-cart') || !('IntersectionObserver' in window)) return;
    const real = document.querySelector('#main-cart-footer .cart__checkout-button');
    if (!real || real.disabled) return;
    const bar = document.createElement('div');
    bar.className = 'plr-cart-mbar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<button type="submit" form="cart" name="checkout" class="cart__checkout-button button plr-cart-mbar__btn" tabindex="-1"><span>Ödemeye geç</span><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M5 12h14m-6-6 6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    document.body.appendChild(bar);
    const io = new IntersectionObserver((entries) => {
      const target = document.querySelector('#main-cart-footer .cart__checkout-button');
      const visible = entries.some((e) => e.isIntersecting) || !target || target.disabled;
      bar.classList.toggle('is-visible', !visible);
    });
    io.observe(real);
  });

  /* ---------- Koleksiyon filtreleri ----------
     İçerik müşterinin final filtreleme prototipine göredir (gruplar, seçenek sırası, açık gruplar,
     sıralama). Ürün verisi snippets/pl-filter-data'dan gelir (data-pf-*). Parfüm sayfalarında
     Koku Karakteri, Tatlılık, Yayılım, Koku Yönü, Konsantrasyon ve Fiyat (birden fazla değer varsa;
     ör. Tüm Parfümler'de iki fiyat, tek koleksiyonda tek fiyat olduğu için görünmez) ve Bileşenler;
     Ortam Kokuları'nda Ürün Türü ve Koku Karakteri; diğerlerinde Koku Karakteri. */
  const CHARACTER_ORDER = ['Ferah', 'Çiçeksi', 'Meyvemsi', 'Odunsu', 'Sıcak', 'Narenciye', 'Misk', 'Marin', 'Şipre', 'Oryantal', 'Miskli', 'Pudralı', 'Gurme', 'Amber', 'Fujer', 'Aromatik', 'Beyaz Çiçekler', 'Baharatlı', 'Amberli', 'Tatlı'];
  const FEATURED_NOTES = ['Vanilya', 'Misk', 'Amber', 'Gül', 'Yasemin', 'Sandal Ağacı', 'Sedir Ağacı', 'Paçuli', 'Müge', 'Limon', 'Kahve', 'Deri'];
  const NOTE_ALIASES = { 'Müge': ['inci çiçeği', 'lily of the valley'], 'Siklamen': ['cyclamen'], 'Mor Salkım (Wisteria)': ['wisteria'], 'Itır (Geranyum)': ['geranyum', 'geranium'], 'Muskat': ['küçük hindistan cevizi', 'nutmeg'], 'Orris (İris Kökü)': ['iris'], 'Labdanum (Laden Reçinesi)': ['laden'], 'Amberimsi Akor': ['amberimsi'], 'Kremsi Akor': ['kremsi'] };
  // Filtre grupları (sekmeler) her zaman açık başlar (kullanıcı isteği, 29 Ekim)
  const FACETS = [
    { key: 'group', label: 'Ürün Türü', attr: 'pfGroup', order: ['Çubuklu Ortam Kokusu', 'Oda Parfümü', 'Araç Parfümü', 'Kokulu Mum', 'Kolonya'], home: true },
    { key: 'char', label: 'Koku Karakteri', attr: 'pfChar' },
    { key: 'sweet', label: 'Tatlılık', attr: 'pfSweet', order: ['Düşük', 'Dengeli', 'Belirgin'], perf: true },
    { key: 'proj', label: 'Yayılım', attr: 'pfProj', order: ['Tene yakın / Yakın çevre', 'Belirgin'], perf: true },
    /* Koku Yönü: ürün sayfasındaki Feminen / Unisex, Maskülen / Unisex bilgisinden (data-pf-dir); birden çok yönü olan
       ürün her yönde bulunur, Unisex 14 parfümün tamamını getirir (müşterinin yayın öncesi düzeltme listesi, 30 Ekim) */
    { key: 'gender', label: 'Koku Yönü', attr: 'pfDir', order: ['Feminen', 'Unisex', 'Maskülen'], perf: true, help: 'Kokunun genel karakter yönünü belirtir; kullanımını sınırlandırmaz.' },
    { key: 'conc', label: 'Konsantrasyon', attr: 'pfConc', order: ['Eau de Parfum', 'Extrait de Parfum'], perf: true },
    { key: 'ing', label: 'Bileşenler', attr: 'pfIng', perf: true, notes: true, help: 'Koku notalarını gösterir; içerik veya alerjen listesi değildir.' },
    { key: 'price', label: 'Fiyat', perf: true },
  ];
  /* Ayrıcalıklı Seçki sayfası (isimsiz 11 parfüm) ayrı filtre seti: ParfumLab_Ayricalikli_11_Parfum_Filtreler_FINAL.xlsx.
     Yalnız Koku Karakteri, Koku Yönü ve Fiyat; Tatlılık, Yayılım, Konsantrasyon ve Bileşenler gösterilmez. */
  const AY_FACETS = [
    { key: 'char', label: 'Koku Karakteri', attr: 'pfAyChar', order: ['Gurme', 'Baharatlı', 'Şipre', 'Amberli', 'Odunsu', 'Çiçeksi', 'Meyvemsi', 'Oryantal', 'Pudralı'] },
    { key: 'dir', label: 'Koku Yönü', attr: 'pfAyDir', order: ['Feminen', 'Unisex', 'Maskülen'] },
    { key: 'price', label: 'Fiyat' },
  ];
  /* Ev & Yaşam (İndirimli Formüller) Koku Karakteri: çoklu değer, dosyadaki seçenek sırası
     (ParfumLab_Ev_Yasam_31_Urun_Coklu_Filtre_FINAL.json). Uzun listede arama ve "Tümünü gör". */
  const EV_CHAR_ORDER = ['Meyvemsi', 'Çiçeksi', 'Aromatik', 'Gurme', 'Narenciye', 'Ozonsu', 'Çay', 'Odunsu', 'Miskli', 'Pudralı', 'Marin', 'Amber', 'Ferah', 'Şipre', 'Oryantal', 'Fujer', 'Beyaz Çiçekler', 'Baharatlı', 'Amberli', 'Tatlı'];
  const EV_GROUPS = ['Çubuklu Ortam Kokusu', 'Oda Parfümü', 'Araç Parfümü', 'Kokulu Mum', 'Kolonya'];
  const LIST_FIRST = 8;
  const collator = new Intl.Collator('tr');
  const esc = (value) => String(value).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const norm = (value) => String(value || '').toLocaleLowerCase('tr-TR').normalize('NFD').replace(/[̀-ͯ]/g, '');
  const noteMatches = (note, query) => !query || [note, ...(NOTE_ALIASES[note] || [])].some((name) => norm(name).includes(norm(query)));
  const tl = (value) => new Intl.NumberFormat('tr-TR').format(value);

  class PlCollection extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-pl-grid]');
      this.facetDefs = this.closest('[data-pl-scope="unnamed"]') ? AY_FACETS : FACETS;
      this.posters = [...this.grid.querySelectorAll('[data-pl-poster]:not([data-pl-poster-last])')];
      this.posterLast = this.grid.querySelector('[data-pl-poster-last]');
      this.items = Array.from(this.grid.children).filter((el) => !el.hasAttribute('data-pl-poster')).map((el) => ({ el, index: +el.dataset.plIndex, values: this.valuesOf(el), perf: el.hasAttribute('data-pf-perf') }));
      this.perf = this.items.length > 0 && this.items.every((item) => item.perf);
      this.selected = {};
      this.sortMode = 'recommended';
      /* Başlıktaki sekmeler (Tümü / alt koleksiyonlar) */
      this.tab = '';
      this.tabs = Array.from(this.closest('.plr-collection')?.querySelectorAll('[data-pl-tab]') || []);
      this.tabs.forEach((tab) => tab.addEventListener('click', () => {
        this.tab = tab.dataset.plTab;
        this.tabs.forEach((t) => { t.classList.toggle('is-active', t === tab); t.setAttribute('aria-selected', String(t === tab)); });
        this.apply();
      }));
      /* Ev & Yaşam sayfaları: seçilmemiş, sonucu olmayan seçenekler gizlenir ve karakterler dosyadaki sırayla (FINAL kuralı) */
      this.classList.toggle('is-ev', this.items.length > 0 && this.items.every((item) => EV_GROUPS.includes(item.values.group[0])));
      this.facets = this.facetDefs.map((facet) => ({ ...facet, options: this.optionsOf(facet) })).filter((facet) => {
        if (facet.perf && !this.perf) return false;
        if (facet.home && this.perf) return false;
        return facet.key === 'char' || facet.key === 'ing' ? facet.options.length > 0 : facet.options.length > 1;
      });
      this.renderGroups();
      this.sizePoster();
      this.watchPosterColumns();
      /* Fiyata göre sıralama yalnız birden fazla fiyatın olduğu parfüm sayfalarında (Tüm Parfümler) */
      const sortSelect = this.querySelector('[data-pl-sort]');
      if (sortSelect && !this.facets.some((facet) => facet.key === 'price')) sortSelect.querySelectorAll('option[value^="price"]').forEach((option) => option.remove());
      this.addEventListener('change', (event) => {
        const input = event.target;
        if (input.matches('[data-pl-sort]')) {
          const label = this.querySelector('[data-pl-sort-label]');
          if (label) label.textContent = input.selectedOptions[0].textContent;
          this.sortMode = input.value;
          return this.sort();
        }
        if (!input.dataset.facet) return;
        const set = (this.selected[input.dataset.facet] ||= new Set());
        input.checked ? set.add(input.value) : set.delete(input.value);
        this.apply();
      });
      this.addEventListener('input', (event) => {
        if (event.target.matches('[data-pl-note-search]')) this.searchNotes(event.target);
      });
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-pl-reset]')) this.reset();
        const chip = event.target.closest('[data-pl-chip]');
        if (chip) {
          this.selected[chip.dataset.facet]?.delete(chip.dataset.value);
          const input = this.querySelector(`input[data-facet="${chip.dataset.facet}"][value="${CSS.escape(chip.dataset.value)}"]`);
          if (input) input.checked = false;
          this.apply();
        }
        const more = event.target.closest('[data-pl-more]');
        if (more) {
          const group = more.closest('.plr-filter');
          group.classList.toggle('is-expanded');
          more.textContent = group.classList.contains('is-expanded') ? 'Daha az göster' : more.dataset.label;
        }
        if (event.target.closest('[data-pl-filters-open]')) this.toggleDrawer(true);
        if (event.target.closest('[data-pl-filters-close]')) this.toggleDrawer(false);
        /* Panel açıkken karartılmış zemine (bileşenin ::before katmanı) tıklayınca kapanır */
        if (event.target === this && this.classList.contains('is-filters-open')) this.toggleDrawer(false);
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-filters-open')) this.toggleDrawer(false);
      });
      this.apply();
    }

    valuesOf(el) {
      const values = {};
      FACETS.forEach((facet) => { values[facet.key] = []; });
      this.facetDefs.forEach((facet) => {
        if (facet.attr) values[facet.key] = (el.dataset[facet.attr] || '').split('|').map((v) => v.trim()).filter(Boolean);
      });
      values.collections = (el.dataset.plCollections || '').split('|').filter(Boolean);
      values.price_cents = +el.dataset.plPrice || 0;
      values.price = values.price_cents ? [`${tl(values.price_cents / 100)} TL`] : [];
      values.title = el.dataset.plTitle || '';
      return values;
    }

    optionsOf(facet) {
      const options = Array.from(new Set(this.items.flatMap((item) => item.values[facet.key] || [])));
      if (facet.key === 'price') return options.sort((a, b) => parseInt(a.replace(/\D/g, ''), 10) - parseInt(b.replace(/\D/g, ''), 10));
      if (facet.order) return facet.order.filter((v) => options.includes(v));
      if (facet.key === 'char' && this.perf) return CHARACTER_ORDER.filter((v) => options.includes(v));
      if (facet.key === 'char' && this.classList.contains('is-ev')) return [...EV_CHAR_ORDER.filter((v) => options.includes(v)), ...options.filter((v) => !EV_CHAR_ORDER.includes(v)).sort(collator.compare)];
      return options.sort(collator.compare);
    }

    optionRow(facet, option, extra) {
      return `
        <label class="plr-option${extra ? ' plr-option--extra' : ''}"${facet.notes || facet.long ? ` data-note="${esc(option)}"` : ''}>
          <input type="checkbox" data-facet="${facet.key}" value="${esc(option)}">
          <span class="plr-option__box" aria-hidden="true"></span>
          <span class="plr-option__label">${esc(option)}</span>
          <span class="plr-option__count" data-count></span>
        </label>`;
    }

    renderGroups() {
      const container = this.querySelector('[data-pl-groups]');
      container.innerHTML = this.facets.map((facet) => {
        let body;
        if (facet.notes) {
          const featured = FEATURED_NOTES.filter((v) => facet.options.includes(v));
          const rest = facet.options.filter((v) => !featured.includes(v));
          const label = `Tüm bileşenleri göster (${facet.options.length})`;
          body = `<p class="plr-filter__help">Sevdiğin notaları seç. Bir bileşenin bulunması kokuda baskın olduğu anlamına gelmez.</p>
            <input type="search" class="plr-filter__search" placeholder="Bileşen ara..." autocomplete="off" aria-label="Bileşen ara" data-pl-note-search>
            ${featured.map((option) => this.optionRow(facet, option, false)).join('')}
            ${rest.map((option) => this.optionRow(facet, option, true)).join('')}
            <p class="plr-filter__help" data-pl-note-empty hidden>Eşleşen bileşen bulunamadı.</p>
            ${rest.length ? `<button type="button" class="plr-link-button plr-filter__more" data-pl-more data-label="${label}">${label}</button>` : ''}
            <p class="plr-filter__note">${facet.options.length} standart isim · İlk ekranda ${featured.length} öne çıkan bileşen</p>`;
        } else if (facet.key === 'char' && !this.perf && facet.options.length > LIST_FIRST) {
          /* Uzun karakter listesi (Ev & Yaşam, 22 birleşik değer): arama + ilk 8 + "Tümünü gör" */
          facet.long = true;
          const label = `Tümünü gör (${facet.options.length})`;
          body = `<input type="search" class="plr-filter__search" placeholder="Karakter ara..." autocomplete="off" aria-label="Koku karakteri ara" data-pl-note-search>
            ${facet.options.map((option, i) => this.optionRow(facet, option, i >= LIST_FIRST)).join('')}
            <p class="plr-filter__help" data-pl-note-empty hidden>Eşleşen karakter bulunamadı.</p>
            <button type="button" class="plr-link-button plr-filter__more" data-pl-more data-label="${label}">${label}</button>`;
        } else {
          body = (facet.help ? `<p class="plr-filter__help">${facet.help}</p>` : '') + facet.options.map((option) => this.optionRow(facet, option, false)).join('');
        }
        return `
        <details class="plr-filter" open>
          <summary>${facet.label}<span class="plr-filter__icon" aria-hidden="true"></span></summary>
          <div class="plr-filter__options">${body}</div>
        </details>`;
      }).join('');
    }

    searchNotes(field) {
      const group = field.closest('.plr-filter');
      const query = field.value.trim();
      let found = 0;
      group.classList.toggle('is-searching', Boolean(query));
      group.querySelectorAll('[data-note]').forEach((row) => {
        const match = noteMatches(row.dataset.note, query);
        row.hidden = Boolean(query) && !match;
        if (query && match) found += 1;
      });
      group.querySelector('[data-pl-note-empty]').hidden = !query || found > 0;
      const more = group.querySelector('[data-pl-more]');
      if (more) more.hidden = Boolean(query);
    }

    matches(item, except) {
      if (this.tab && !item.values.collections.includes(this.tab)) return false;
      return Object.entries(this.selected).every(([key, set]) => {
        if (key === except || !set.size) return true;
        return item.values[key].some((v) => set.has(v));
      });
    }

    apply() {
      let visible = 0;
      this.items.forEach((item) => {
        const show = this.matches(item);
        item.el.hidden = !show;
        if (show) visible += 1;
      });
      this.querySelectorAll('input[data-facet]').forEach((input) => {
        const n = this.items.filter((item) => this.matches(item, input.dataset.facet) && item.values[input.dataset.facet].includes(input.value)).length;
        const label = input.closest('.plr-option');
        label.querySelector('[data-count]').textContent = String(n); /* Web FINAL: sayı parantezsiz */
        label.classList.toggle('is-empty', n === 0 && !input.checked);
        input.disabled = n === 0 && !input.checked;
      });
      const active = Object.entries(this.selected).flatMap(([key, set]) => Array.from(set).map((value) => ({ key, value })));
      const activeCount = active.length;
      this.querySelectorAll('[data-pl-count]').forEach((el) => (el.textContent = visible));
      const badge = this.querySelector('[data-pl-active-count]');
      badge.hidden = !activeCount;
      badge.textContent = activeCount;
      const chips = this.querySelector('[data-pl-chips]');
      chips.hidden = !activeCount;
      chips.innerHTML = active.map(({ key, value }) => `<button type="button" class="plr-chip" data-pl-chip data-facet="${key}" data-value="${esc(value)}" aria-label="${esc(value)} filtresini kaldır">${esc(value)}<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="m5 5 14 14M19 5 5 19"/></svg></button>`).join('');
      this.querySelector('[data-pl-empty]').hidden = visible > 0;
      if (this.sortMode === 'recommended') this.sort();
    }

    reset() {
      this.selected = {};
      this.querySelectorAll('input[data-facet]').forEach((input) => (input.checked = false));
      this.apply();
    }

    /* Önerilen sıralama: seçilen koku karakteri ürünün ana karakteriyse önce, sonra eşleşen ikincil karakter ve bileşen sayısı */
    sort() {
      const items = [...this.items];
      const chars = this.selected.char || new Set();
      const notes = this.selected.ing || new Set();
      const score = (item) => (chars.has(item.values.char[0]) ? 100 : 0) + item.values.char.slice(1).filter((v) => chars.has(v)).length * 20 + item.values.ing.filter((v) => notes.has(v)).length * 5;
      if (this.sortMode === 'az') items.sort((a, b) => collator.compare(a.values.title, b.values.title));
      else if (this.sortMode === 'za') items.sort((a, b) => collator.compare(b.values.title, a.values.title));
      else if (this.sortMode === 'priceUp') items.sort((a, b) => a.values.price_cents - b.values.price_cents || a.index - b.index);
      else if (this.sortMode === 'priceDown') items.sort((a, b) => b.values.price_cents - a.values.price_cents || a.index - b.index);
      else if (chars.size || notes.size) items.sort((a, b) => score(b) - score(a) || a.index - b.index);
      else items.sort((a, b) => a.index - b.index);
      items.forEach((item) => this.grid.appendChild(item.el));
      /* Posterler (sections/pl-collection-grid): yalnız filtresiz, önerilen sıralamada. Önce hepsi sona alınır
         (son sıra posteri en sonda), sonra her biri data-pl-poster-after ürününün ardına (yoksa 6. sıraya) yerleşir. */
      if (this.posters.length || this.posterLast) {
        const plain = this.sortMode === 'recommended' && !Object.values(this.selected).some((set) => set.size);
        this.posters.forEach((poster) => this.grid.appendChild(poster));
        if (this.posterLast) { this.posterLast.hidden = !plain; this.grid.appendChild(this.posterLast); }
        /* Listede önce gelen ürünün posteri önce yerleşir; sonraki yerleşimler öncekinin hizasını bozmaz */
        const rank = (poster) => {
          const h = poster.dataset.plPosterAfter;
          const i = h ? items.findIndex((item) => item.el.querySelector(`a[href*="/products/${h}"]`)) : 4;
          return i < 0 ? Infinity : i;
        };
        [...this.posters].sort((a, b) => rank(a) - rank(b)).forEach((poster) => {
          const shown = [...this.grid.children].filter((el) => !el.hidden && !el.hasAttribute('data-pl-poster'));
          const afterHandle = poster.dataset.plPosterAfter;
          const anchor = afterHandle ? shown.find((el) => el.querySelector(`a[href*="/products/${afterHandle}"]`)) : shown[4];
          poster.hidden = !plain || !anchor || (!afterHandle && shown.length < 6);
          if (poster.hidden) return;
          /* Ürünler hep formül sırasında kalır (kullanıcı isteği, 29 Ekim); poster ürünün hemen ardına,
             data-pl-poster-desktop-left ise masaüstünde (990px+) hemen önüne girer. Sütun düzeni gereği poster
             bazen alt satıra düşebilir; ürün sırası bunun için değiştirilmez. */
          const left = afterHandle && poster.hasAttribute('data-pl-poster-desktop-left') && window.matchMedia('(min-width: 990px)').matches;
          this.grid.insertBefore(poster, left ? anchor : anchor.nextSibling);
        });
        this.sizePoster();
      }
    }

    /* Poster boyu = komşu ürün görselinin boyu (kartın tamamı değil; oran ekrana göre değişir) */
    sizePoster() {
      const posters = [...this.posters, this.posterLast].filter(Boolean);
      if (!posters.length) return;
      const media = this.grid.querySelector('.plr-grid__item:not([data-pl-poster]):not([hidden]) .card__media');
      if (!media) return;
      if (!this.posterObserver && window.ResizeObserver) {
        this.posterObserver = new ResizeObserver(() => this.sizePoster());
        this.posterObserver.observe(media);
      }
      const box = media.getBoundingClientRect();
      posters.forEach((poster) => {
        poster.style.setProperty('height', box.height + 'px', 'important');
        poster.style.setProperty('max-width', box.width + 'px', 'important');
      });
    }

    /* Poster konumu yalnız masaüstü/mobil sınırı (990px; data-pl-poster-desktop-left) aşılınca yeniden hesaplanır.
       Mobilde kaydırırken adres çubuğu her açılıp kapandığında "resize" gelir; eskiden her seferinde bütün kartlar
       yeniden dizildiği için görseller bir an beyaz görünüyordu (3 Kasım). Poster boyu ResizeObserver ile ayrıca uyar. */
    watchPosterColumns() {
      if ((!this.posters.length && !this.posterLast) || this.posterResize) return;
      const desktop = window.matchMedia('(min-width: 990px)');
      this.posterResize = () => { if (this.sortMode === 'recommended') this.sort(); };
      if (desktop.addEventListener) desktop.addEventListener('change', this.posterResize); else if (desktop.addListener) desktop.addListener(this.posterResize);
    }

    toggleDrawer(open) {
      const wasOpen = this.classList.contains('is-filters-open');
      this.classList.toggle('is-filters-open', open);
      document.documentElement.classList.toggle('plr-lock', open);
      /* Odak panele taşınır, kapanınca Filtrele düğmesine döner */
      if (open && !wasOpen) setTimeout(() => this.querySelector('.plr-filters__close')?.focus({ preventScroll: true }), 50);
      if (!open && wasOpen) this.querySelector('[data-pl-filters-open]')?.focus({ preventScroll: true });
    }
  }
  if (!customElements.get('plr-collection')) customElements.define('plr-collection', PlCollection);

  /* ---------- Ürün sayfası ---------- */
  class PlrGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-plr-track]');
      if (!this.track) return;
      this.current = this.querySelector('[data-plr-current]');
      this.dotGroups = this.querySelectorAll('.plr-gallery__dots');
      this.prev = this.querySelector('[data-plr-prev]');
      this.next = this.querySelector('[data-plr-next]');
      this.count = this.track.children.length;
      this.thumbList = this.querySelector('[data-plr-thumbs]');
      this.thumbs = Array.from(this.querySelectorAll('[data-plr-thumb]'));
      this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.go(+thumb.dataset.plrThumb)));
      /* Alttaki küçük resim satırının yüksekliği: sayaç ve oklar görselin üstünde kalsın */
      const thumbsBox = this.querySelector('.plr-gallery__thumbs');
      if (thumbsBox && this.classList.contains('plr-gallery--thumbs-bottom')) {
        const setH = () => this.style.setProperty('--plr-thumbs-h', `${thumbsBox.offsetHeight}px`);
        setH();
        if ('ResizeObserver' in window) new ResizeObserver(setH).observe(thumbsBox);
      }
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.prev?.addEventListener('click', () => this.go(this.index - 1));
      this.next?.addEventListener('click', () => this.go(this.index + 1));
      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.go(this.index + 1); }
      });
      this.bindDrag();
      this.update();
      /* Kendiliğinden geçiş (ör. Mağazalarımız üst görselleri); dokunma veya ok tıklamasında durur */
      const autoplay = +this.dataset.autoplay;
      if (autoplay && this.count > 1) {
        this.timer = setInterval(() => this.go(this.index + 1 >= this.count ? 0 : this.index + 1), autoplay);
        const stop = () => clearInterval(this.timer);
        ['pointerdown', 'touchstart', 'keydown'].forEach((type) => this.addEventListener(type, stop, { passive: true, once: true }));
      }
    }

    get index() {
      return Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1));
    }

    go(index) {
      const target = Math.max(0, Math.min(this.count - 1, index));
      this.track.scrollTo({ left: target * this.track.clientWidth, behavior: 'smooth' });
    }

    update() {
      const index = this.index;
      if (this.current) this.current.textContent = String(index + 1).padStart(2, '0');
      this.dotGroups.forEach((group) => group.querySelectorAll('i').forEach((dot, i) => dot.classList.toggle('is-active', i === index)));
      this.thumbs?.forEach((thumb, i) => {
        const active = i === index;
        thumb.classList.toggle('is-active', active);
        if (active) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');
        /* Etkin küçük resim listede görünür kalır (sayfa kaydırılmadan) */
        if (active && this.thumbList) {
          const list = this.thumbList;
          if (list.scrollWidth > list.clientWidth) {
            /* Yatay liste (Creative Formula, görselin altında) */
            if (thumb.offsetLeft < list.scrollLeft) list.scrollLeft = thumb.offsetLeft;
            else if (thumb.offsetLeft + thumb.offsetWidth > list.scrollLeft + list.clientWidth) list.scrollLeft = thumb.offsetLeft + thumb.offsetWidth - list.clientWidth;
          } else if (thumb.offsetTop < list.scrollTop) list.scrollTop = thumb.offsetTop;
          else if (thumb.offsetTop + thumb.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = thumb.offsetTop + thumb.offsetHeight - list.clientHeight;
        }
      });
      if (this.prev) this.prev.disabled = index <= 0;
      if (this.next) this.next.disabled = index >= this.count - 1;
    }

    /* Fareyle basılı tutup kaydırma; bırakınca en yakın görsele oturur */
    bindDrag() {
      const track = this.track;
      let drag = null;
      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        drag = { x: event.clientX, left: track.scrollLeft, start: this.index, moved: false };
        track.setPointerCapture(event.pointerId);
      });
      track.addEventListener('pointermove', (event) => {
        if (!drag) return;
        const dx = event.clientX - drag.x;
        if (!drag.moved && Math.abs(dx) > 4) {
          drag.moved = true;
          track.classList.add('is-dragging');
        }
        if (drag.moved) track.scrollLeft = drag.left - dx;
      });
      const end = (event) => {
        if (!drag) return;
        const { moved, start, x } = drag;
        drag = null;
        if (!moved) return;
        const dx = event.clientX - x;
        const threshold = track.clientWidth * 0.12;
        const target = dx < -threshold ? start + 1 : dx > threshold ? start - 1 : start;
        this.go(target);
        const release = () => track.classList.remove('is-dragging');
        if ('onscrollend' in window) track.addEventListener('scrollend', release, { once: true });
        else setTimeout(release, 450);
        track.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); }, { capture: true, once: true });
      };
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
    }
  }
  if (!customElements.get('plr-gallery')) customElements.define('plr-gallery', PlrGallery);

  class PlrDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-plr-drawer-close]')) this.close();
        const city = event.target.closest('[data-plr-city]');
        if (city) {
          this.querySelectorAll('[data-plr-city]').forEach((el) => el.classList.toggle('is-active', el === city));
          this.querySelectorAll('[data-plr-city-item]').forEach((el) => (el.hidden = city.dataset.plrCity !== '' && el.dataset.plrCityItem !== city.dataset.plrCity));
        }
      });
      this.addEventListener('keydown', (event) => event.key === 'Escape' && this.close());
    }
    open(opener) {
      clearTimeout(this.hideTimer);
      this.opener = opener;
      this.hidden = false;
      document.documentElement.classList.add('plr-lock');
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        this.querySelector('[role="dialog"]').focus();
      });
    }
    close() {
      this.classList.remove('is-open');
      document.documentElement.classList.remove('plr-lock');
      clearTimeout(this.hideTimer);
      this.hideTimer = setTimeout(() => (this.hidden = true), 300);
      this.opener?.focus({ preventScroll: true });
    }
  }
  if (!customElements.get('plr-drawer')) customElements.define('plr-drawer', PlrDrawer);

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-plr-drawer-open]');
    if (opener) {
      event.preventDefault();
      document.getElementById(opener.dataset.plrDrawerOpen)?.open(opener);
    }
    const share = event.target.closest('[data-plr-share]');
    if (share) {
      const data = { title: share.dataset.title, url: share.dataset.url };
      if (navigator.share) navigator.share(data).catch(() => {});
      else if (navigator.clipboard) navigator.clipboard.writeText(data.url).then(() => {
        const label = share.firstChild;
        const previous = label.textContent;
        label.textContent = 'Bağlantı kopyalandı';
        setTimeout(() => (label.textContent = previous), 1600);
      });
    }
    const toggle = event.target.closest('[data-plr-review-toggle]');
    if (toggle) {
      const form = document.getElementById(toggle.getAttribute('aria-controls'));
      form.hidden = !form.hidden;
      toggle.setAttribute('aria-expanded', String(!form.hidden));
      if (!form.hidden) form.querySelector('input[name="name"]').focus();
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-plr-review-form]');
    if (!form) return;
    event.preventDefault();
    form.querySelector('[data-plr-review-done]').hidden = false;
    form.querySelector('button[type="submit"]').disabled = true;
  });

  /* Çeşit seçimi (birden fazla varyantlı ürünler) */
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-plr-variant]');
    if (!select) return;
    const option = select.selectedOptions[0];
    const section = select.closest('.plr-pdp')?.parentElement || document;
    document.querySelectorAll('[data-plr-price]').forEach((el) => (el.textContent = option.dataset.price));
    document.querySelectorAll('[data-plr-sticky-id]').forEach((el) => (el.value = select.value));
    const available = option.dataset.available === 'true';
    section.querySelectorAll('[data-plr-atc]').forEach((button) => {
      button.disabled = !available;
      button.querySelector('span').textContent = available ? 'Sepete ekle' : 'Çok Yakında';
    });
  });

  /* Mobilde ana "Sepete ekle" görünmezken alttaki çubuk çıkar */
  ready(() => {
    const sticky = document.querySelector('[data-plr-sticky]');
    const main = document.querySelector('[data-plr-atc]');
    if (!sticky || !main || !('IntersectionObserver' in window)) return;
    sticky.hidden = false;
    /* Satın alma kartındaki buton ekranda değilken (ör. sayfanın aşağısında) çubuk görünür */
    new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting);
    }).observe(main);
  });

  /* Deneyim noktası listesi şehir filtresi (Mağazalarımız sayfası; panelin içindeki liste panelin kendi koduyla çalışır) */
  document.addEventListener('click', (event) => {
    const city = event.target.closest('[data-plr-city]');
    const list = city?.closest('[data-plr-stores]');
    if (!list || list.closest('plr-drawer')) return;
    list.querySelectorAll('[data-plr-city]').forEach((el) => el.classList.toggle('is-active', el === city));
    list.querySelectorAll('[data-plr-city-item]').forEach((el) => (el.hidden = city.dataset.plrCity !== '' && el.dataset.plrCityItem !== city.dataset.plrCity));
  });

  /* Sözleşme ve politika sayfaları (sections/pl-legal-page): sayfa metni değiştirilmeden bölümlere
     ayrılır. Başlık sayılanlar: h2–h4, yalnız kalın paragraf, kısa numaralı satır ("1. TARAFLAR"),
     kısa büyük harfli ya da başlık biçimli satır; satır kırılımlı uzun metinde büyük harfli satırlar
     ve "BÖLÜM n" satırları. İlk başlık sayfa adının tekrarıysa belge başlığı olarak üstte kalır.
     Her bölüme "01 / BİLGİ" etiketi eklenir. Sonuçtaki harfler orijinalle birebir aynı değilse
     (boşluklar hariç) sayfa olduğu gibi bırakılır. */
  (() => {
    const root = document.querySelector('[data-plr-legal]');
    if (!root) return;
    const backup = root.innerHTML;
    const flat = (node) => {
      const copy = node.cloneNode(true);
      copy.querySelectorAll('br').forEach((br) => br.replaceWith(' '));
      copy.querySelectorAll('[data-plr-added]').forEach((el) => el.remove());
      return copy.textContent.replace(/ /g, ' ').replace(/\s+/g, ' ').trim();
    };
    const letters = (node) => flat(node).replace(/\s+/g, '');
    const key = (text) => text.toLocaleLowerCase('tr-TR').replace(/ı/g, 'i').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/parfumlab|[–\-()]/g, ' ').replace(/\s+/g, ' ').trim();
    const before = letters(root);
    const title = key(root.dataset.title || '');
    const NUM = /^\d{1,2}(?:\.\d{1,2})*[.)]\s+\S/;
    const TOP_NUM = /^(\d{1,2})[.)]\s+\S/;
    const SECTION_WORD = /^(?:BÖLÜM|SECTION)\s+(\d{1,2})\b/i;
    const LINK_WORDS = new Set(['ve', 'ile', 'veya', 'için', 'de', 'da', '&', '–', '-', '/']);
    const isCaps = (t) => t === t.toLocaleUpperCase('tr-TR') && /[A-ZÇĞİÖŞÜ]{3}/.test(t);
    const isTitleLine = (t) => {
      const words = t.split(/\s+/);
      return t.length <= 60 && words.length <= 8 && !/[:@]|https?:/.test(t) && !t.startsWith('(')
        && words.every((w, i) => /^[A-ZÇĞİÖŞÜ0-9“"'(]/.test(w) || (i > 0 && LINK_WORDS.has(w)));
    };
    const numOf = (t) => +((t.match(TOP_NUM) || t.match(SECTION_WORD) || [])[1] || 0);
    const pad = (n) => String(n).padStart(2, '0');
    const runIn = /^(\d{1,2}(?:\.\d{1,2})*[.)]\s+[^.]{2,60}\.)(?=\s|$)/;
    const para = (text) => {
      const p = document.createElement('p');
      const m = text.match(runIn);
      if (m) {
        const b = document.createElement('strong');
        b.textContent = m[1];
        p.append(b, text.slice(m[1].length));
      } else p.textContent = text;
      return p;
    };
    const units = [];
    /* Satır kırılımlı metin (PDF'ten aktarılmış): satırlar paragraflara akıtılır */
    const reflow = (node) => {
      const copy = node.cloneNode(true);
      copy.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));
      const lines = copy.textContent.replace(/ /g, ' ').split('\n').map((l) => l.replace(/\s+/g, ' ').trim());
      let buf = null;
      let heading = null;
      const flush = () => { if (buf) units.push({ kind: 'p', el: para(buf), reflowed: true }); buf = null; };
      for (let i = 0; i < lines.length; i += 1) {
        const line = lines[i];
        if (!line) { flush(); heading = null; continue; }
        if (SECTION_WORD.test(line) || (isCaps(line) && !/[:;,]$/.test(line))) {
          flush();
          if (heading && isCaps(line)) { heading.text += ' ' + line; continue; }
          let text = line;
          while ((text.match(/\(/g) || []).length > (text.match(/\)/g) || []).length && lines[i + 1]) text += ' ' + lines[(i += 1)];
          heading = { kind: 'h', text, level: 9 };
          units.push(heading);
          continue;
        }
        heading = null;
        if (NUM.test(line)) { flush(); buf = line; continue; }
        buf = buf ? buf + ' ' + line : line;
      }
      flush();
    };
    for (const node of [...root.childNodes]) {
      if (node.nodeType === 3) {
        if (node.textContent.trim()) units.push({ kind: 'p', el: para(node.textContent.trim()) });
        continue;
      }
      if (node.nodeType !== 1 || node.tagName === 'HR') continue;
      const text = flat(node);
      if (!text) continue;
      if (/^H[1-6]$/.test(node.tagName)) { units.push({ kind: 'h', node, text, level: +node.tagName[1] }); continue; }
      if (node.tagName === 'P' || (node.tagName === 'DIV' && !node.querySelector('p, ul, ol, table, div, h1, h2, h3, h4, h5, h6'))) {
        const brs = node.querySelectorAll('br').length;
        if (brs >= 3 && text.length > 300) { reflow(node); continue; }
        const bold = [...node.querySelectorAll('strong, b')].map(flat).join(' ').replace(/\s+/g, ' ').trim();
        const heading = !brs && text.length <= 120 && !/[:;,]$/.test(text)
          && (bold === text || (text.length <= 90 && (TOP_NUM.test(text) || isCaps(text) || isTitleLine(text))));
        units.push(heading ? { kind: 'h', node, text, level: 9 } : { kind: 'b', node });
        continue;
      }
      units.push({ kind: 'b', node });
    }
    const dup = units[0] && units[0].kind === 'h' && title && (key(units[0].text).includes(title) || title.includes(key(units[0].text))) ? units[0] : null;
    let heads = units.filter((u) => u.kind === 'h' && u !== dup);
    /* Başlıksız satır kırılımlı metin (ör. Kargo ve Teslimat): "1. Teslim süreleri." gibi maddeler bölüm olur */
    if (!heads.length) {
      for (let i = units.length - 1; i >= 0; i -= 1) {
        const u = units[i];
        if (!u.reflowed || !TOP_NUM.test(u.el.textContent)) continue;
        const lead = u.el.firstChild && u.el.firstChild.nodeName === 'STRONG' ? u.el.firstChild : null;
        if (lead) lead.remove();
        /* Başlığı ayrılamayan madde (ör. "6. İade Taşıyıcısı ... Cayma hakkı") yalnız etiketle bölüm olur */
        units.splice(i, 0, { kind: 'h', text: lead ? lead.textContent : '', num: numOf(u.el.textContent), level: 9 });
      }
      heads = units.filter((u) => u.kind === 'h' && u !== dup);
    }
    if (!heads.length) return;
    const level = Math.min(...heads.map((h) => h.level));
    const numbered = heads.some((h) => h.level === level && (h.num || numOf(h.text)));
    const fill = (unit, target) => {
      if (unit.node) target.append(...unit.node.childNodes);
      else target.textContent = unit.text;
      return target;
    };
    const make = (tag, cls) => Object.assign(document.createElement(tag), { className: cls });
    const out = document.createDocumentFragment();
    let box = null;
    let count = 0;
    units.forEach((unit) => {
      if (unit === dup) { out.append(fill(unit, make('p', 'plr-legal__doc-title'))); return; }
      if (unit.kind === 'h' && unit.level === level) {
        count += 1;
        box = make('section', 'plr-legal__section');
        const n = unit.num || numOf(unit.text);
        const eyebrow = make('p', 'plr-legal__eyebrow');
        eyebrow.dataset.plrAdded = '';
        eyebrow.textContent = numbered ? (n ? `${pad(n)} / BİLGİ` : 'BİLGİ') : `${pad(count)} / BİLGİ`;
        box.append(eyebrow);
        if (unit.node || unit.text) box.append(fill(unit, make('h2', 'plr-legal__h')));
        out.append(box);
        return;
      }
      if (!box) { box = make('div', 'plr-legal__intro'); out.append(box); }
      if (unit.kind === 'h') box.append(fill(unit, make('h3', 'plr-legal__sub')));
      else box.append(unit.el || unit.node);
    });
    root.replaceChildren(out);
    root.classList.add('is-formatted');
    if (letters(root) !== before) {
      root.innerHTML = backup;
      root.classList.remove('is-formatted');
    }
  })();

  /* Alt bilgi: mobilde Sözleşmeler / Politikalar menüleri açılır-kapanır */
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-plr-footer-toggle]');
    if (!toggle) return;
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', open);
    toggle.closest('.plr-footer__column').classList.toggle('is-open', open);
  });

  /* ---------- Çıkış penceresi (masaüstü) ---------- */
  class PlrExit extends HTMLElement {
    connectedCallback() {
      this.delay = (+this.dataset.delay || 8) * 1000;
      this.armedAt = Date.now() + this.delay;
      const fine = window.matchMedia('(pointer: fine) and (min-width: 990px)').matches;
      let seen = false;
      try { seen = sessionStorage.getItem('plr-exit-seen') === '1'; } catch (e) {}
      if (!fine || seen) return;
      this.onLeave = (event) => {
        if (event.relatedTarget || event.clientY > 0 || Date.now() < this.armedAt) return;
        if (document.body.classList.contains('promo-popup--open') || document.querySelector('.plr-drawer.is-open, details[open] > .menu-drawer, .cart-drawer-container[open]')) return;
        this.open();
      };
      document.addEventListener('mouseout', this.onLeave);
      this.addEventListener('click', (event) => event.target.closest('[data-plr-exit-close]') && this.close());
      this.addEventListener('keydown', (event) => event.key === 'Escape' && this.close());
    }
    async open() {
      document.removeEventListener('mouseout', this.onLeave);
      try { sessionStorage.setItem('plr-exit-seen', '1'); } catch (e) {}
      let cart = null;
      try { cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json(); } catch (e) {}
      const hasItems = cart && cart.item_count > 0;
      this.querySelector('[data-plr-exit-mode="cart"]').hidden = !hasItems;
      this.querySelector('[data-plr-exit-mode="picks"]').hidden = hasItems;
      /* Sepet kartları sunucuda (sections/pl-exit-intent) çizilir; güncel sepet için bölüm yeniden çekilir */
      const section = this.closest('[id^="shopify-section-"]');
      if (hasItems && section) {
        try {
          const id = section.id.replace('shopify-section-', '');
          const data = await (await fetch(`${window.location.pathname}?sections=${encodeURIComponent(id)}`)).json();
          const fresh = new DOMParser().parseFromString(data[id], 'text/html').querySelector('[data-plr-exit-items]');
          if (fresh) this.querySelector('[data-plr-exit-items]').innerHTML = fresh.innerHTML;
        } catch (e) { /* sayfa yüklenirkenki liste kalır */ }
      }
      this.hidden = false;
      document.documentElement.classList.add('plr-lock');
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        this.querySelector('[role="dialog"]').focus();
      });
    }
    close() {
      this.classList.remove('is-open');
      document.documentElement.classList.remove('plr-lock');
      setTimeout(() => (this.hidden = true), 250);
    }
  }
  if (!customElements.get('plr-exit')) customElements.define('plr-exit', PlrExit);

  /* Mobil alt menünün gerçek yüksekliği (temanın ölçümü menü gizliyken 0 kalıyor) */
  ready(() => {
    const dock = document.querySelector('mobile-dock');
    if (!dock) return;
    const set = () => document.documentElement.style.setProperty('--plr-dock-height', `${getComputedStyle(dock).display !== 'none' ? dock.offsetHeight : 0}px`);
    set();
    window.addEventListener('resize', set, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(dock);
    setTimeout(set, 600);
  });

  /* Başlık yüksekliği: yapışkan ürün sütunları ve galeri için */
  ready(() => {
    const header = document.querySelector('.shopify-section-header');
    const set = () => document.documentElement.style.setProperty('--plr-header-h', `${header ? Math.round(header.getBoundingClientRect().height) : 90}px`);
    set();
    window.addEventListener('resize', set, { passive: true });
  });

  /* Ürün sütunları: ekrana sığıyorsa yapışkan, sığmıyorsa (ör. akordeon açılınca) sayfayla birlikte kayar */
  ready(() => {
    const columns = document.querySelectorAll('[data-plr-smart-sticky]');
    if (!columns.length) return;
    const update = () => {
      const top = (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--plr-header-h'), 10) || 90) + 16;
      columns.forEach((column) => column.classList.toggle('is-sticky', window.innerWidth >= 990 && column.offsetHeight + top + 16 <= window.innerHeight));
    };
    update();
    window.addEventListener('resize', update, { passive: true });
    if ('ResizeObserver' in window) columns.forEach((column) => new ResizeObserver(update).observe(column));
  });

  /* Değerlendirme sayısına tıklayınca yorumlara yumuşak kaydırma (yapışkan başlık payıyla) */
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#plr-reviews"]');
    if (!link) return;
    const target = document.getElementById('plr-reviews');
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    const offset = (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--plr-header-h'), 10) || 90) + 16;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
  }, true);

  /* iPhone düşük güç modu sessiz videoların kendiliğinden oynamasını engeller; ziyaretçinin ilk dokunuşunda
     görünen hero videoları başlatılır (dokunuş sonrası iOS oynatmaya izin verir) */
  ready(() => {
    const videos = Array.from(document.querySelectorAll('[data-video-hero] video'));
    if (!videos.length) return;
    const events = ['touchend', 'click', 'keydown'];
    const stop = () => events.forEach((type) => document.removeEventListener(type, kick, true));
    function kick() {
      const waiting = videos.filter((video) => video.paused && video.getClientRects().length);
      if (!waiting.length) return stop();
      waiting.forEach((video) => { video.muted = true; video.play().catch(() => {}); });
    }
    events.forEach((type) => document.addEventListener(type, kick, { capture: true, passive: true }));
  });

  /* Mobil hero: gösteri ilk slayttan (video) başlar; tema mobilde ikinci slayttan başlattığı için başa alınır */
  ready(() => {
    const slideshow = document.querySelector('slideshow-component .plr-mobile-slide')?.closest('slideshow-component');
    if (!slideshow) return;
    /* Tema mobil eşleşmede gösteriyi yeniden kurar; her yeni kurulumda bir kez başa alınır (ilk 6 sn) */
    let last = null;
    let tries = 0;
    const timer = setInterval(() => {
      const { flickitySmall: small, flickityLarge: large } = slideshow;
      if (small && large && small !== last) {
        last = small;
        requestAnimationFrame(() => { if (large.selectedIndex !== 0) small.select(0, false, true); });
      }
      if (++tries > 120) clearInterval(timer);
    }, 50);
  });

  /* Slayt gösterisi: video slaytında otomatik geçiş videonun süresi kadar bekler (tema her slayta sabit süre veriyor) */
  ready(() => {
    document.querySelectorAll('slideshow-component[data-autorotate="true"]').forEach((slideshow) => {
      const base = parseInt(slideshow.dataset.autorotateSpeed, 10) || 5000;
      const attach = () => {
        const small = slideshow.flickitySmall;
        const large = slideshow.flickityLarge;
        if (!small || !large || !small.player) return false;
        const apply = () => {
          const video = large.selectedElement && large.selectedElement.querySelector('video');
          const dot = slideshow.querySelector('.flickity-page-dot.is-selected');
          slideshow.querySelectorAll('.flickity-page-dot').forEach((el) => el !== dot && el.style.removeProperty('--plr-dot'));
          if (!video) {
            small.options.autoPlay = base;
            small.player.autoPlay = base;
            small.player.tick();
            return;
          }
          const run = () => {
            const ms = Math.max(base, Math.round(video.duration * 1000));
            small.options.autoPlay = ms;
            small.player.autoPlay = ms;
            if (dot) dot.style.setProperty('--plr-dot', `${ms / 1000}s`);
            try { video.currentTime = 0; } catch (e) {}
            const playing = video.play();
            if (playing && playing.catch) playing.catch(() => {});
            small.player.tick();
          };
          if (Number.isFinite(video.duration) && video.duration > 0) run();
          else video.addEventListener('loadedmetadata', run, { once: true });
        };
        large.on('select', apply);
        apply();
        return true;
      };
      let tries = 0;
      const timer = setInterval(() => {
        if (attach() || ++tries > 60) clearInterval(timer);
      }, 250);
    });
  });

  /* Mobilde bir alana yazarken alttaki sepete ekle çubuğu ve alt menü klavyenin üstünde formu kapatmasın */
  const isTypingField = (el) => el && el.matches && el.matches('input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]), textarea, select');
  document.addEventListener('focusin', (event) => {
    if (isTypingField(event.target)) document.documentElement.classList.add('plr-typing');
  });
  document.addEventListener('focusout', () => {
    setTimeout(() => {
      if (!isTypingField(document.activeElement)) document.documentElement.classList.remove('plr-typing');
    }, 50);
  });

  window.ParfumLabRedesign = { ready };
})();

/* Sepet çekmecesi önerileri (sections/mini-cart, pl-rec-random): her grup (koleksiyon) için adaylardan rastgele biri
   gösterilir; çekmece her yenilendiğinde yeniden seçilir (kullanıcı isteği, 29 Ekim) */
if (!customElements.get('pl-rec-random')) {
  customElements.define('pl-rec-random', class extends HTMLElement {
    connectedCallback() {
      const groups = {};
      this.querySelectorAll('li[data-pl-rec]').forEach((li) => { (groups[li.dataset.plRec] ||= []).push(li); });
      let shown = 0;
      Object.values(groups).forEach((list) => {
        const pick = list[Math.floor(Math.random() * list.length)];
        if (pick) { pick.hidden = false; shown += 1; }
      });
      if (!shown) this.hidden = true;
    }
  });
}
